/* Speculative prefetch on hover/touchstart - makes navigation feel instant.
 * Uses <link rel="prefetch"> via JS since speculation rules API isn't universal yet.
 * Only prefetches internal product/collection links and respects connection quality. */
(function () {
  if (!('connection' in navigator) ? false : navigator.connection && (navigator.connection.saveData || /(2|3)g/.test(navigator.connection.effectiveType))) {
    return; // Don't prefetch on slow connections or save-data mode
  }

  var prefetched = new Set();
  var prefetchHead = document.head;
  var hoverTimer;
  var HOVER_DELAY = 65; // ms — only prefetch if user pauses on link, avoids prefetching on fast scrolls
  var SUPPORTS_PREFETCH = (function () {
    var l = document.createElement('link');
    return l.relList && l.relList.supports && l.relList.supports('prefetch');
  })();
  if (!SUPPORTS_PREFETCH) return;

  function shouldPrefetch(href) {
    if (!href) return false;
    if (prefetched.has(href)) return false;
    try {
      var url = new URL(href, location.href);
      if (url.origin !== location.origin) return false;
      // Only product and collection pages
      if (!/\/(products|collections)\//.test(url.pathname)) return false;
      // Don't prefetch the page we're already on
      if (url.pathname === location.pathname) return false;
      // Don't prefetch cart, account, etc
      if (/\/(cart|account|checkouts?|orders|admin)/.test(url.pathname)) return false;
      return true;
    } catch (e) {
      return false;
    }
  }

  function doPrefetch(href) {
    if (!shouldPrefetch(href)) return;
    prefetched.add(href);
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    link.as = 'document';
    prefetchHead.appendChild(link);
  }

  function getLinkHref(target) {
    var anchor = target && target.closest && target.closest('a[href]');
    if (!anchor) return null;
    if (anchor.target === '_blank') return null;
    if (anchor.hasAttribute('download')) return null;
    return anchor.href;
  }

  // Hover with delay
  document.addEventListener('mouseover', function (e) {
    var href = getLinkHref(e.target);
    if (!href) return;
    clearTimeout(hoverTimer);
    hoverTimer = setTimeout(function () { doPrefetch(href); }, HOVER_DELAY);
  }, { passive: true });

  document.addEventListener('mouseout', function () {
    clearTimeout(hoverTimer);
  }, { passive: true });

  // Touchstart (mobile) - immediate, since touchstart already implies intent
  document.addEventListener('touchstart', function (e) {
    var href = getLinkHref(e.target);
    if (href) doPrefetch(href);
  }, { passive: true, capture: true });

  // Focus (keyboard navigation)
  document.addEventListener('focusin', function (e) {
    var href = getLinkHref(e.target);
    if (href) doPrefetch(href);
  }, { passive: true });
})();
